<template>
  <svg
    class="rr-icon"
    :class="classes"
    aria-hidden="true"
  >
    <use :xlink:href="`#icon-${name}`" />
  </svg>
</template>

<script>
export default {
  name: 'Icon',
  designVersion: '1.0.0',
  props: {
    /**
     * Название иконки
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * Размер иконки
     */
    size: {
      type: String,
      validator(value) {
        return ['', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    classes() {
      const classes = {};
      if (this.size) {
        classes[`rr-icon_${this.size}`] = true;
      }
      return classes;
    },
  },
};
</script>

<style lang="scss">
$icon-sizes: (
  xxs: 12px,
  xs: 14px,
  s: 16px,
  m: 18px,
  l: 20px,
  xl: 24px,
  xxl: 32px,
) !default;

.rr-icon {
  fill: currentColor;
  overflow: hidden;
  max-width: 100%;
  max-height: 100%;

  @each $name, $value in $icon-sizes {

    &_#{$name} {
      width: $value;
      height: $value;
    }
  }
}
</style>
